// @ts-expect-error untyped import
import { handleActions } from 'flux-actions';
import * as ActionTypes from 'MeetingsLib/redux/actions/ActionTypes';
const initialState = null;
export default handleActions({
  [ActionTypes.SET_LEGITIMATE_INTEREST_CONFIRMED]() {
    return true;
  }
}, initialState);